import React from "react"
import styled from "styled-components"

const HeaderButton = (props) => {
  return (
    <OuterDiv isBordered={props.isBordered} isDark={props.isDark}>
      <img src={props.src} alt={props.alt} />
    </OuterDiv>
  )
}

const OuterDiv = styled.div`
  border-left: 1px solid
    ${(props) =>
      props.isBordered ? props.theme.borderColorLight : "transparent"};
  height: ${(props) => props.theme.headerHeight}px;
  position: relative;
  width: ${(props) => props.theme.headerHeight}px;
  img {
    height: 44%;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  &:last-of-type {
    border-right: 1px solid ${(props) => props.theme.borderColorLight};
  }
`

HeaderButton.defaultProps = {
  isBordered: true,
}

export {HeaderButton}
